import React from "react"
import { AppProviderChips } from "@components"


export default function providersColumn() {
	return {
		name: "providers_translation", label: "Providers",
		options: {
			sort: false,
			headerAlign: 'center',
			customBodyRowRenderLite: value => <AppProviderChips providers={[...value].sort((a, b) => a.localeCompare(b))} sx={{ justifyContent: 'center' }}/>
		}
	}
}